import { createContext, useState } from "react";
import { languages } from "../languages";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("preferredLang") || "en"
  );

  const t = (path) => {
    return path
      .split(".")
      .reduce((obj, key) => obj?.[key], languages[selectedLanguage]);
  };

  return (
    <LanguageContext.Provider
      value={{ selectedLanguage, setSelectedLanguage, t }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
